import { Flex } from 'antd';
import { ReactNode } from 'react';

import { useFullscreenHidden } from '../../utils/use-fullscreen-hidden';

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Action buttons / controls rendered on the right side */
  extra?: ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Standard page header with title + optional subtitle and right-side actions.
 * Automatically collapses (height → 0) when the app enters fullscreen mode.
 */
const PageHeader = ({ title, subtitle, extra, style, className }: PageHeaderProps) => {
  const isFullscreen = useFullscreenHidden();

  return (
    <div
      style={{
        height: isFullscreen ? 0 : 'auto',
        overflow: 'hidden',
        transition: 'height 0.25s ease',
        marginBottom: isFullscreen ? 0 : 16,
        ...style,
      }}
      className={className}
    >
      <Flex justify="space-between" align="flex-start" wrap="wrap" gap={16}>
        <Flex vertical gap={4}>
          {title}
          {subtitle}
        </Flex>
        {extra && <div>{extra}</div>}
      </Flex>
    </div>
  );
};

export default PageHeader;
